import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { toast } from "react-toastify";
import "./admin.css";
import { useUserId } from "../../Utils/helpers";

const apiBaseUrl = "https://mattersmith6.embeddedexperience.com/api";

const AdminSettings = () => {
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [newSecret, setNewSecret] = useState("");
  const [show, setShow] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [charLimitExceeded, setCharLimitExceeded] = useState(false);
  const userId = useUserId();

  useEffect(() => {
    const fetchClientTokens = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/client-tokens/${userId}/`
        );
        const data = response.data.data;
        if (Array.isArray(data)) {
          setTableData(data);
        } else {
          console.error("Unexpected API response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching client tokens:", error);
      }
    };

    fetchClientTokens();
  }, [userId]);

  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    setNewSecret("");
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSave = async () => {
    try {
      if (newSecret.trim()) {
        const response = await axios.post(`${apiBaseUrl}/client-token/`, {
          user_id: userId,
          client_name: newSecret,
        });
        toast.success(response.data.success);
        handleClose();
        const fetchClientTokens = async () => {
          try {
            const response = await axios.get(
              `${apiBaseUrl}/client-tokens/${userId}/`
            );
            const data = response.data.data;
            if (Array.isArray(data)) {
              setTableData(data);
            } else {
              console.error("Unexpected API response format:", response.data);
            }
          } catch (error) {
            console.error("Error fetching client tokens:", error);
          }
        };
        fetchClientTokens();
      } else {
        toast.error("Secret name cannot be empty or only spaces!");
      }
    } catch (error) {
      console.error("Error saving new secret:", error);
    }
  };

  const handleRemove = async () => {
    try {
      const clientNamesToRemove = selectedItems.map((item) => item.name);

      const resp = await axios.post(`${apiBaseUrl}/remove-tokens/`, {
        user_id: userId,
        client_names: clientNamesToRemove,
      });

      if (resp) {
        toast.success(resp.data.success);
      }

      const fetchClientTokens = async () => {
        try {
          const response = await axios.get(
            `${apiBaseUrl}/client-tokens/${userId}/`
          );
          const data = response.data.data;

          if (data === null) {
            setTableData([]);
            setSelectedItems([]);
          } else if (Array.isArray(data)) {
            setTableData(data);
            setSelectedItems([]);
          } else {
            console.error("Unexpected API response format:", response.data);
          }
        } catch (error) {
          console.error("Error fetching client tokens:", error);
        }
      };

      fetchClientTokens();
    } catch (error) {
      console.error("Error removing selected items:", error);
    }
  };

  const filteredData = Array.isArray(tableData)
    ? tableData.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  return (
    <div className="admin-settings-container">
      <div className="ms-card">
        <div className="card-heading d-flex align-items-center justify-content-between gap-3 w-100">
          <h3 className="heading-text m-0">Admin Settings</h3>
          <div className="d-flex align-items-center gap-3">
            <div className="mr-16 position-relative">
              <input
                id="input1"
                name="input1-group2"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchChange}
                type="text"
                className="search-color ms-input ms-input-md searchs m-0 form-control custom-searchbar"
              />
            </div>
            <Button onClick={handleShow} className="add-secret-button">
              Add Secret
            </Button>
          </div>
        </div>
        <div className="table-container">
          <table className="ms-table w-100">
            <thead>
              <tr>
                <th>Select</th>
                <th>Name</th>
                <th>Client Token</th>
                <th>Client Secret</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                    borderBottom: "1px solid #e0e6ed",
                  }}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item)}
                      onChange={() => {
                        setSelectedItems((prev) => {
                          if (prev.includes(item)) {
                            return prev.filter((i) => i !== item);
                          } else {
                            return [...prev, item];
                          }
                        });
                      }}
                      aria-label="select"
                    />
                  </td>
                  <td>{item.name}</td>
                  <td style={{ whiteSpace: "nowrap", userSelect: "all" }}>
                    {item.token}
                  </td>
                  <td style={{ whiteSpace: "nowrap", userSelect: "all" }}>
                    {item.secret}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal for adding a new secret */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>Secret</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="newSecret" className="form-label">
              Please enter secret name
            </label>
            <textarea
              className="form-control"
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.length > 40) {
                  setCharLimitExceeded(true);
                } else {
                  setCharLimitExceeded(false);
                }
                setNewSecret(inputValue.slice(0, 40).replace(/^\s+$/, ""));
              }}
              value={newSecret}
              id="newSecret"
              aria-describedby="secretHelp"
            />

            {charLimitExceeded && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                Character limit exceeded! Max 40 characters allowed.
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSave}
            className="remove-button remove-button-container"
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add the Remove button */}
      <div className="footer">
        <Button
          onClick={selectedItems.length != 0 ? handleRemove : () => {}}
          className="remove-button remove-button-container"
          disabled={selectedItems.length === 0}
        >
          Remove
        </Button>
      </div>
    </div>
  );
};

export default AdminSettings;
